import React, { useState, useEffect } from 'react';
import { List, message } from 'antd';
import connect from "react-redux/es/connect/connect";

import { deleteChannelsAction } from "../../../actions/channelsStoreActions";

import FeedChannelItem from './FeedChannelItem';

import './ChannelList.less';

const chanDescrLengthFromWidth = {
  320: 80,
  480: 180,
  576: 190,
  768: 80,
  992: 130,
  1020: 70,
  1200: 130,
  1600: 240
};

const ChannelList = ({ data, pathFrom, pageType, subscriptions }) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    updateWindowDimensions();
  }, []);

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
  }, [width, height]);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  const handleDeleteChannel = async(event, channel) => {
    event.preventDefault();

    const result = deleteChannelsAction(channel)
    result.then((res) => {
      if (res === 'success') {
        message.success(`Channel ${channel.title} - deleted`);
      }
    })
  }

  return (
    <List
      itemLayout="vertical"
      size="large"
      className="list-horizontal list-mobile-small"
      grid={{
        gutter: 28,
        xs: 1,
        md: 2,
      }}
      dataSource={data}
      renderItem={(item) => {
        const keys = Object.keys(chanDescrLengthFromWidth);
        const markers = keys.map(key => (width >= parseInt(key)) ? true : false);
        let indexEl = 0;
        markers.forEach((boolean, index) => boolean ? indexEl = index : null );
        const currentLength = chanDescrLengthFromWidth[keys[indexEl]];
        const description = (item.description.length > currentLength) ? item.description.slice(0, currentLength) + '...' : item.description;

        const subscribersNumber = subscriptions && Object.keys(subscriptions).reduce((result, next) => {
          const length = subscriptions[next].filter(subscription => subscription === item.id).length;
          return result + length;
        }, 0);

        return (
          <FeedChannelItem
            item={item}
            pathFrom={pathFrom}
            handleDeleteChannel={handleDeleteChannel}
            description={description}
            eventsNumber={item.eventsNumber}
            subscribersNumber={subscribersNumber}
            pageType={pageType}
          />
        )
      }}
    />
  );
};

export default connect(null, { deleteChannelsAction })(ChannelList);



// WEBPACK FOOTER //
// ./src/components/Modules/ChannelList/index.js